import React from "react";

const LocateUs = () => {
  return (
    <div className="p-4 flex flex-col lg:flex-row  lg:items-center lg:justify-between bg-gray-100 shadow-md ">
      <div className="lg:w-1/2 p-4">
        <p className="font-bold md:text-[20px]  text-[18px]">
          Office Address
        </p>
        <p className="">Aditya & Associates</p>
        <p>
          Shop No. 17, Babulin Complex, Plot No. 40/44,
          <br />
          S.V. Road, Malad (W), Mumbai, Maharashtra - 400064.
        </p>
        <div className="mt-4 space-y-3">
          <a
            href="tel:+919987858709"
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-800"
          >
            <img
              src="./svgIcons/phone-call-24.svg"
              alt="Phone"
              className="h-6 w-6"
            />
            <span>+91 99878 58709</span>
          </a>
          <a
            href="https://wa.me/+919987858709"
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-800"
          >
            <img
              src="./svgIcons/whatsapp-128.svg"
              alt="WhatsApp"
              className="h-5 w-5 mr-1"
            />
            <span>WhatsApp</span>
          </a>
          <a
            href="mailto:adityassociates0510@gmail.com"
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-800"
          >
            <img
              src="./svgIcons/mail-pencil.svg"
              alt="Email"
              className="h-6 w-6"
            />
            <span>adityassociates0510@gmail.com</span>
          </a>
          <a
            href="https://www.aditya-and-associates.com/"
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-800"
          >
            <img
              src="./svgIcons/webnet.svg"
              alt="Email"
              className="h-6 w-6"
            />
            <span>www.aditya-and-associates.com</span>
          </a>
        </div>
      </div>


      <div className="lg:w-1/2 w-full p-4">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d236.53861044076058!2d72.84663871263152!3d19.1814355155756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7d7ac55a23f%3A0x3c3e4bfd8eaedd54!2sAditya%20%26%20Associates!5e0!3m2!1sen!2sin!4v1736680655763!5m2!1sen!2sin"
          height="300"
          className="w-full h-[250px] lg:h-[300px] rounded-lg shadow-lg"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default LocateUs;
